import AuthModel from '@/models/Auth';

const LOG_OUT = 'LOG_OUT';
const SILENT_YSF_LOGIN = 'SILENT_YSF_LOGIN';
const REGISTER_YSF_BY_MOBILE = 'REGISTER_YSF_BY_MOBILE';
const GET_WX_OPENID_BY_CODE = 'GET_WX_OPENID_BY_CODE';
const SEND_AUTH_MESSAGE = 'SEND_AUTH_MESSAGE';
const REGISTER_SHOP_BY_MOBILE = 'REGISTER_SHOP_BY_MOBILE';
const GET_WX_CONFIG = 'GET_WX_CONFIG';
const GET_WX_REGISTER_INFO_BY_CODE = 'GET_WX_REGISTER_INFO_BY_CODE';
const SEND_WX_AUTH_MESSAGE = 'SEND_WX_AUTH_MESSAGE';
const REGISTER_SHOP_BY_WX = 'REGISTER_SHOP_BY_WX';

/**
 * 退出登录 
 */
async function logOut() {
  return {
    type: LOG_OUT
  }
}

/**
 * 云闪付静默登录
 * @param {string} code 云闪付基础授权 code
 */
async function silentYSFLogin(code) {
  const payload = await new AuthModel().silentYSFLogin(code);
  return {
    type: SILENT_YSF_LOGIN,
    payload
  }
}

/**
 * 云闪付注册
 * @param {string} code 云闪付手机号授权 code
 */
async function registerYSFByMobile(code) {
  const payload = await new AuthModel().registerYSF(code);
  return {
    type: REGISTER_YSF_BY_MOBILE,
    payload
  }
}

/**
 * 获取微信openid
 * @param {string} code 微信授权 code
 */
async function getWXOpenidByCode(code) {
  const payload = await new AuthModel().getWXOpenidByCode(code);
  return {
    type: GET_WX_OPENID_BY_CODE,
    payload
  }
}

/**
 * 发送短信验证码
 * @param {String} phone 手机号
 * @param {String} verifyCode 图形验证码
 */
async function sendAuthMessage({ phone, verifyCode }) {
  const payload = await new AuthModel().sendMessage({ phone, verifyCode });
  return {
    type: SEND_AUTH_MESSAGE,
    payload
  }
}

/**
 * H5商城注册
 * @param {String} phone 手机号
 * @param {String} verifyCode 图形验证码
 * @param {String} password 用户密码或短信验证码
 * @param {Number} type 注册类型 1-密码注册 2-短信验证码注册
 */
async function registerShopByMobile(params) {
  const payload = await new AuthModel().register(params);
  return {
    type: REGISTER_SHOP_BY_MOBILE,
    payload
  }
}

/**
 * 获取微信配置参数
 */
async function getWXConfig(params) {
  const payload = await new AuthModel().wxConfig(params);
  return {
    type: GET_WX_CONFIG,
    payload
  }
}

/**
 * 根据微信授权信息判断用户注册状态
 */
async function getWXRegisterInfoByCode(code) {
  const payload = await new AuthModel().getWXRegisterInfoByCode(code);
  return {
    type: GET_WX_REGISTER_INFO_BY_CODE,
    payload
  }
}

/**
 * 根据微信授权信息发送短信验证码
 * @param {String} phone 手机号
 */
async function sendWXAuthMessage({ phone }) {
  const payload = await new AuthModel().sendWXMessage({ phone });
  return {
    type: SEND_WX_AUTH_MESSAGE,
    payload
  }
}

/**
 * 根据微信授权信息注册
 * @param {String} phone 手机号
 * @param {String} password 用户密码或短信验证码
 */
async function registerShopByWX(params) {
  const payload = await new AuthModel().wxRegister(params);
  return {
    type: REGISTER_SHOP_BY_WX,
    payload
  }
}

const ACTION_TYPES = {
  LOG_OUT,
  SILENT_YSF_LOGIN,
  REGISTER_YSF_BY_MOBILE,
  GET_WX_OPENID_BY_CODE,
  SEND_AUTH_MESSAGE,
  REGISTER_SHOP_BY_MOBILE,
  GET_WX_CONFIG,
  GET_WX_REGISTER_INFO_BY_CODE,
  SEND_WX_AUTH_MESSAGE,
  REGISTER_SHOP_BY_WX,
};

const ACTION = {
  logOut,
  silentYSFLogin,
  registerYSFByMobile,
  getWXOpenidByCode,
  sendAuthMessage,
  registerShopByMobile,
  getWXConfig,
  getWXRegisterInfoByCode,
  sendWXAuthMessage,
  registerShopByWX,
};

const Auth = {
  ACTION_TYPES,
  ACTION
}

export default Auth;